export enum AlertPriority {
  EXTREME = '4',
  SEVERE = '3',
  MODERATE = '2',
  MINOR = '1',
  UNKNOWN = '0'
}